import { render } from "./ListPagination.vue?vue&type=template&id=f30d113e&scoped=true"
import script from "./ListPagination.vue?vue&type=script&lang=js"
export * from "./ListPagination.vue?vue&type=script&lang=js"

import "./ListPagination.vue?vue&type=style&index=0&id=f30d113e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f30d113e"]])

export default __exports__